"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var Option_1 = require("fp-ts/lib/Option");
/*
    In order to prevent revision entities from being stored and overwriting our current data,
    we will alter all ids in a response containing a 'RefInfo' to be <originalid>:<revision>
    This has to include references as well as id fields, so we need the viewConfig to figure out what fields to replace.

    We can assume most prior preprocessing has already been done.
*/
var isObject = function (value) { return !!value && value.constructor === Object; };
var isArray = function (value) { return !!value && value.constructor === Array; };
var isEntityWithId = function (data) {
    return isObject(data) && data['id'] && data['entityType'];
}; // tslint:disable-line
var isWildcardReference = function (data) {
    return isObject(data) && data['id'] && data['schema'] && Object.keys(data).length === 2;
}; // tslint:disable-line
var isRevision = function (data) {
    return isObject(data) &&
        data['revInfo'] &&
        data['entity'] && // tslint:disable-line
        // just in case we haven't stripped out a jsog market
        Object.keys(data).length <= 4;
};
var getIsOfDatatype = function (dataTypes) { return function (viewConfig) { return function (currEntityType, field) {
    return (0, Option_1.fromNullable)(viewConfig.entities[currEntityType])
        .chain(function (e) { return (0, Option_1.fromNullable)(e.fields[field]); })
        .map(function (f) { return f.dataType; })
        .fold(false, function (dt) { return dataTypes.indexOf(dt) !== -1; });
}; }; };
var getIsId = getIsOfDatatype(['REFONE', 'REFONEJOIN']);
var getIsIds = getIsOfDatatype(['REFMANYMANY', 'REFMANY', 'REFMANYJOIN']);
var getSourceFromField = function (f) { return (f.endsWith('Id') ? f.slice(0, -2) : f.endsWith('Ids') ? f.slice(0, -3) : f); };
// for now, lets assume we can figure out if we are looking at a revision at the top level.
var getApplyRevisionToAllIds = function (viewConfig) {
    var isId = getIsId(viewConfig);
    var isIds = getIsIds(viewConfig);
    var getAppend = function (toAppend) { return function (v) {
        // this oculd be an expansion!!
        if (isWildcardReference(v)) {
            return __assign(__assign({}, v), { id: "".concat(v.id, ":").concat(toAppend) });
        }
        if (isRevision(v)) {
            // start a new revision recursion
            return applyRevisionNumberToAllIds(v);
        }
        if (isArray(v)) {
            return v.map(getAppend(toAppend));
        }
        if (isEntityWithId(v)) {
            // recuse on entity id replacement function
            return updateAllEntityIds(toAppend)(v);
        }
        if (typeof v === 'string' || typeof v === 'number') {
            return "".concat(v, ":").concat(toAppend);
        }
        // throw a runtime exception
        throw new Error("unexpected Expression type ".concat(JSON.stringify(v)));
    }; };
    var updateAllEntityIds = function (toAppend) {
        var append = getAppend(toAppend);
        var updateData = function (data) {
            return Object.assign.apply(Object, __spreadArray([{}], Object.entries(data).map(function (_a) {
                var _b, _c;
                var k = _a[0], v = _a[1];
                return k === 'id' ||
                    isId(data.entityType, getSourceFromField(k)) ||
                    isIds(data.entityType, getSourceFromField(k))
                    ? (_b = {}, _b[k] = append(v), _b) : (_c = {}, _c[k] = v, _c);
            }), false));
        };
        return updateData;
    };
    // type EntityOrRevisionData = Revision | Revision[] | EntityWithId | EntityWithId[];
    var applyRevisionNumberToAllIds = function (data) {
        if (isArray(data)) {
            return data.map(applyRevisionNumberToAllIds);
        }
        if (isRevision(data)) {
            // lets recurse down the entity and replace all ids with the revision number
            var revisionNumber = data.revInfo.revision;
            var updateIds = updateAllEntityIds(revisionNumber);
            return __assign(__assign({}, data), { entity: updateIds(data.entity) });
        }
        return data;
    };
    return applyRevisionNumberToAllIds;
};
exports.default = getApplyRevisionToAllIds;
//# sourceMappingURL=index.js.map